import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import { db } from '../firebaseConfig';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

const EditIcon = () => <span className="edit-icon-bg" style={{ cursor: 'pointer', marginLeft: '8px', opacity: 0.7, position: 'absolute', top: '15px', right: '15px', background: 'rgba(0,0,0,0.6)', color: 'white', padding: '5px 8px', borderRadius: '5px', fontSize:'0.9rem', zIndex: 5 }}>✏️ BG</span>;


const EditableBackground = ({ docPath, field, children, defaultImageUrl = '' }) => {
  const { currentUser } = useAuth();
  const [isEditing, setIsEditing] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [originalImageUrl, setOriginalImageUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      setError(null);
      try {
        const docRef = doc(db, docPath);
        const docSnap = await getDoc(docRef);
        let currentUrl = defaultImageUrl; // Usa default se non trova nulla
        if (docSnap.exists() && docSnap.data()[field]) {
          currentUrl = docSnap.data()[field];
        }
        // Verifica se l'URL è valido prima di impostarlo (base)
        if (currentUrl && typeof currentUrl === 'string' && (currentUrl.startsWith('http') || currentUrl.startsWith('/'))) {
             setImageUrl(currentUrl);
             setOriginalImageUrl(currentUrl);
        } else {
             console.warn(`URL non valido o mancante per ${docPath}/${field}. Uso fallback.`);
             setImageUrl(defaultImageUrl);
             setOriginalImageUrl(defaultImageUrl);
        }

      } catch (err) {
        console.error("Errore caricamento sfondo:", docPath, field, err);
        setError("Errore caricamento sfondo");
        setImageUrl(defaultImageUrl);
        setOriginalImageUrl(defaultImageUrl);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [docPath, field, defaultImageUrl]);

  const handleSave = async () => {
    if (!currentUser) return;
     // Validazione URL più robusta (semplice regex)
     const urlPattern = /^(http|https):\/\/[^ "]+$/;
     const localPattern = /^\/[^ "]+$/; // Per URL relativi come /default-hero-bg.jpg
     if (imageUrl.trim() && !urlPattern.test(imageUrl.trim()) && !localPattern.test(imageUrl.trim())) {
         alert("Inserisci un URL valido (es. https://...) o un percorso relativo (es. /immagine.jpg).");
         return;
     }


    const docRef = doc(db, docPath);
    const dataToSave = {
        [field]: imageUrl.trim(), // Salva URL
        [`${field}_lastUpdatedBy`]: currentUser.email,
        [`${field}_updatedAt`]: serverTimestamp()
    };
    try {
      await setDoc(docRef, dataToSave, { merge: true });
      setOriginalImageUrl(imageUrl.trim()); // Aggiorna originale con valore trimmato
      setIsEditing(false);
      setError(null);
    } catch (err) {
      console.error("Errore salvataggio sfondo:", err);
      setError("Errore salvataggio sfondo");
      alert("Errore durante il salvataggio.");
    }
  };

  const handleCancel = () => {
      setImageUrl(originalImageUrl);
      setIsEditing(false);
      setError(null);
  }

  const backgroundStyle = imageUrl ? { backgroundImage: `url(${imageUrl})` } : {};

  return (
    // Applica classe 'editing' per styling specifico
    <div className={`editable-background-wrapper ${isEditing ? 'editing' : ''}`} style={backgroundStyle}>
      {children}

      {currentUser && !isEditing && (
        <span onClick={() => setIsEditing(true)}><EditIcon /></span>
      )}

      {currentUser && isEditing && (
        <div className="editable-background-controls">
          <label htmlFor={`imageUrlInput-${field}`}>URL Sfondo:</label>
          <input
            type="url"
            id={`imageUrlInput-${field}`} // ID univoco
            value={imageUrl}
            onChange={(e) => setImageUrl(e.target.value)}
            placeholder="Incolla URL https://... o /percorso/relativo.jpg"
            // Rimuovi stile inline se gestito da CSS
          />
          <button onClick={handleSave}>Salva</button>
          <button onClick={handleCancel}>Annulla</button>
          {error && <p className="error-message">{error}</p>}
        </div>
      )}
      {loading && <div className="loading-overlay"><span> </span></div>}
    </div>
  );
};

export default EditableBackground;